import React, { useState } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import SuperAdminHeader from "./Header";
import SuperAdminSidebar from "./Sidebar";

const DRAWER_WIDTH = 0;
const MINI_WIDTH = 0;

export default function SuperAdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    try {
      return localStorage.getItem("super_sidebar_open") !== "0";
    } catch {
      return true;
    }
  });

  const toggleSidebar = () => {
    setSidebarOpen((s) => {
      const next = !s;
      try {
        localStorage.setItem("super_sidebar_open", next ? "1" : "0");
      } catch {}
      return next;
    });
  };

  return (
    <Box sx={{ display: "flex" }}>
      <SuperAdminHeader onToggle={toggleSidebar} />
      <SuperAdminSidebar open={sidebarOpen} setOpen={setSidebarOpen} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: "70px",
          ml: sidebarOpen ? `${DRAWER_WIDTH}px` : `${MINI_WIDTH}px`,
          transition: "margin 0.3s ease",
          p: 2,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
